module.exports = __webpack_public_path__ + "fonts/fa-regular-400.3c6879c.woff";